import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const TrackingNewSpot = ({
  bgColor,
}: IconProps = {}): React.ReactElement => {
  return (
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" fill={bgColor || '#F7F5F0'} r="24" />
      <path
        d="M9.6875 15.2277C9.6875 14.4795 10.3767 13.873 11.2268 13.873H27.5439C28.3941 13.873 29.0833 14.4795 29.0833 15.2277V30.9413H11.2268C10.3767 30.9413 9.6875 30.3348 9.6875 29.5867V15.2277Z"
        fill="#38AF88"
      />
      <path
        d="M29.082 21.6298C29.082 20.7728 29.8606 20.0781 30.821 20.0781H34.1882C34.7966 20.0781 35.3608 20.3619 35.6758 20.8263L38.9166 25.604C39.0809 25.8463 39.1678 26.1242 39.1678 26.4075V29.3881C39.1678 30.2451 38.3893 30.9398 37.4289 30.9398H29.082V21.6298Z"
        fill="#184634"
      />
      <path
        d="M31.4102 22.4082H34.2192L36.0651 24.9352V27.0632H31.4102V22.4082Z"
        fill="white"
      />
      <path
        d="M18.2199 31.3297C18.2199 32.8293 17.0041 34.0451 15.5045 34.0451C14.0048 34.0451 12.7891 32.8293 12.7891 31.3297C12.7891 29.83 14.0048 28.6143 15.5045 28.6143C17.0041 28.6143 18.2199 29.83 18.2199 31.3297Z"
        fill="#25694F"
      />
      <path
        d="M36.841 31.3297C36.841 32.8293 35.6252 34.0451 34.1256 34.0451C32.6259 34.0451 31.4102 32.8293 31.4102 31.3297C31.4102 29.83 32.6259 28.6143 34.1256 28.6143C35.6252 28.6143 36.841 29.83 36.841 31.3297Z"
        fill="#25694F"
      />
    </svg>
  );
};
